import { HTTP } from "./HttpServices";

const getItems = (endpoint, query) => {
  if (!query) {
    query = "";
  }
  return HTTP.get(endpoint.concat(query)).then(resp => resp);
};

const createOrUpdate = (endpoint, item) => {
  if (item.id) {
    return HTTP.put(endpoint + "/" + item.id, item);
  } else {
    return HTTP.post(endpoint, item);
  }
};

const remove = (endpoint, itemId) => {
  return HTTP.delete(endpoint.concat("/").concat(itemId));
};

export default {
  getItems,
  createOrUpdate,
  remove
};
